module.exports = __webpack_public_path__ + "img/IMG_2671_L_Black.1b2427c6.jpg";